var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallkrtipayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02607 0H2.1318C0.954538 0 0 0.958766 0 2.14124V26.8614C0 28.0439 0.954538 29.0027 2.1318 29.0027H8.02607C8.39198 29.0027 8.63592 28.6325 8.49804 28.2916C6.79313 24.0304 5.85715 19.3751 5.85715 14.5013C5.85715 9.62761 6.79578 4.97493 8.49804 0.711085C8.63326 0.37019 8.38933 0 8.02607 0Z",
    fill: "#58B8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2585 14.4774C10.2585 19.6094 12.0616 24.318 15.0604 28.0013C15.5695 28.6271 16.3437 28.976 17.1498 28.976H25.0804C25.5762 28.976 25.7698 28.3342 25.3615 28.0519C20.2759 24.571 16.2721 19.6946 16.2721 14.4747V14.496C16.2721 9.27606 20.2785 4.39967 25.3615 0.918817C25.7724 0.64184 25.5789 0 25.0804 0H17.1498C16.3437 0 15.5721 0.348884 15.0604 0.974745C12.0589 4.66067 10.2585 9.36661 10.2585 14.4987V14.4774Z",
    fill: "#58B8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallkrtipayLogo);
export default __webpack_public_path__ + "static/media/smallkrtipay_logo.df85689d360f7bbfd389f274c3e00138.svg";
export { ForwardRef as ReactComponent };